import React, { useEffect, useState } from 'react'
import image1 from '../../Assets/110.avif';
import image2 from '../../Assets/314.avif';
import image3 from '../../Assets/315.avif';
import image4 from '../../Assets/322.avif';
import image5 from '../../Assets/316.avif';
import image6 from '../../Assets/322.avif';
import image7 from '../../Assets/318.avif';
import image8 from '../../Assets/323.avif';
import image9 from '../../Assets/317.avif';
import './Home.css';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { Link } from 'react-router-dom';


const images = [ image1, image2, image3, image4, image5, image6, image7, image8, image9];

function Banner() {
   　 const [currentImage, setCurrentImage] = useState(null);

    useEffect(() => {
      const intervalId = setInterval(() => {
          setCurrentImage(images[Math.floor(Math.random() * images.length)]);
      }, 4000)
      
      return () => clearInterval(intervalId);
  }, [])


  return (
    <>
    <div className="hero min-h-screen" style={{ backgroundImage: `url(${!currentImage ? image1 : currentImage})` }}>
        {/* <div className="hero-overlay bg-opacity-10">
          <h1  style={{fontFamily:'raleway'}}className=" imageText mb-8 text-2xl font-bold px-6 py-2">[Education is Number One]</h1>
        </div> */}
        <div className="hero-content text-center text-neutral-content">
        <div className="max-w-md">
        </div>
      </div>
   </div>

   <div style={{paddingTop:'80px',marginBottom:'40px',textAlign:'left',textDecoration:'underline',display:'flex',paddingLeft:'60px'}}>
      <AiOutlineArrowLeft className="h-6 w-4"/>
      <Link to='/backLink'><p style={{fontFamily:'raleway', paddingLeft:'4px'}}>Back to who we are!</p></Link>
   </div>

   <div style={{backgroundColor:'#6B728E',marginRight:'2%',marginLeft:'2%'}} className="grid h-0.5"></div>

   
</>
  )
}

export default Banner
